import { Alert, Button } from '@ntconsult/aluma-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { type WithTranslation, withTranslation } from 'react-i18next';

type Props = WithTranslation & { children: ReactNode };

type State = { hasError: boolean };

class ErrorBoundaryImpl extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    const { t } = this.props;
    return (
      <main className="grid min-h-dvh place-items-center p-6">
        <div className="flex w-full max-w-md flex-col gap-4">
          <Alert variant="danger" title={t('errorBoundary.title')}>
            {t('errorBoundary.description')}
          </Alert>
          <Button type="button" variant="primary" onClick={() => window.location.reload()}>
            {t('errorBoundary.reload')}
          </Button>
        </div>
      </main>
    );
  }
}

export const ErrorBoundary = withTranslation('common')(ErrorBoundaryImpl);
